import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { downloadData, } from '@/service/main/system'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModal } from '@/hooks/usePageModal'
import { ref } from 'vue'
import PageSearch from '@/components/PageSearch.vue'
import PageContent from '@/components/PageContent.vue'
import PageModal from '@/components/PageModal.vue'
import { useStore } from '@/store'
import { Excel } from '@/utils/ExcelJs'
import { ElNotification, ElMessage, ElLoading } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'stockTagManage',
  setup(__props) {

const store = useStore()
const modalTitle = ref('新增')
const newCb = () => {
  modalTitle.value = '新增'
}

const editCb = () => {
  modalTitle.value = '编辑'
}
const handleDownloadImport = () => {
  const fileName = '股票概念上传模板.xlsx'
  downloadData(
    '/main/stockTag/downloadImport',
    {
      fileName: fileName
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = fileName
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}
let loadingInstance = ref<any>()
const handleImportProgress = (res: any) => {
  loadingInstance.value = ElLoading.service({
    lock: true,
    text: '导入数据中...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}
const handleImportSuccess = (res: any) => {
  // 解绑事件时关闭Loading
  if (loadingInstance.value) {
    loadingInstance.value.close(); // 关闭Loading实例
  }
  if (res.length > 0) {
    const errs = res.map((item: any) => item.reason).join(',')
    ElMessage({
      type: 'error',
      message: '导入存在异常数据如下：' + errs
    })
  } else {
    if(res && res.code){
      ElMessage({
        type: 'warning',
        message: res.message
      })
    }else{
      ElMessage({
        type: 'success',
        message: '导入成功'
      })
      handleSearchClick()
    }
  }
}

const handleImportError = (res: any) => {
  // 解绑事件时关闭Loading
  if (loadingInstance.value) {
    loadingInstance.value.close(); // 关闭Loading实例
  }
  ElMessage({
    type: 'error',
    message: res.message
  })
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "stockTag",
      deleteTip: "确认删除此项吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData),
      onYbwaveDownloadImport: handleDownloadImport,
      onImportProgress: handleImportProgress,
      onImportSuccess: handleImportSuccess,
      onImportError: handleImportError
    }, null, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "stockTag",
      validOtherInfo: () => true
    }, null, 8, ["defaultInfo", "modalConfig", "title"])
  ]))
}
}

})